export enum MarketPricingMode {
  Calculated = "calculated",
  Coefficient = "coefficient",
  AdaptiveCoefficient = "adaptive_coefficient",
}
